var _excluded = ["onChange", "app", "valueKey"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { actions as ppcActions } from '../../../../reducers/ppc.reducer';
import Select from '../Select.react';
var SelectInternalUrl = function SelectInternalUrl(_ref) {
  var _onChange = _ref.onChange,
    app = _ref.app,
    _ref$valueKey = _ref.valueKey,
    valueKey = _ref$valueKey === void 0 ? '_id' : _ref$valueKey,
    rest = _objectWithoutProperties(_ref, _excluded);
  var dispatch = useDispatch();
  var service = useSelector(function (s) {
    return s.ppc.service.index;
  });
  useEffect(function () {
    dispatch({
      type: ppcActions.service,
      payload: {
        route: 'index'
      }
    });
  }, [app]);
  var preValue = '';
  var postValue = '';
  if (valueKey === 'internalUrl') preValue = '/service/';
  return /*#__PURE__*/React.createElement(Select, _extends({
    options: Object.values(service).filter(function (x) {
      return x.clientApp === app && !x.archived;
    }).sort(function (a, b) {
      return a.title.localeCompare(b.title);
    }).map(function (x) {
      return {
        sLabel: x.title,
        sValue: preValue + '' + x[valueKey] + '' + postValue
      };
    })
  }, rest, {
    onChange: function onChange(_ref2) {
      var sValue = _ref2.sValue;
      if (_onChange) _onChange(sValue);
    }
  }));
};
export default SelectInternalUrl;